import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { QuestionHelpTextComponent } from '../component/common-components/question-help-text/question-help-text.component';
import { QuestionHelpText } from '../model/question-help-text';
import { QuestionHelpTextService } from './question-help-text.service';


@Injectable({
  providedIn: 'root'
})
export class HelpTextDialogService {
  lstQuestionHelpText: QuestionHelpText[] = [];
  constructor(
    private dialog: MatDialog,
    private questionHelpTextService: QuestionHelpTextService
  ) {}

  stopClickEvent(event: MouseEvent): void {
    console.log("event stopPropagation ran")
    event.stopPropagation(); // prevent panel from closing when clicking just the <i> help icon
  }
  
 // Help Text
  displayHelpText(qId: number) {
    console.log("helpTextDialogService now invoking Help Text API")

          console.log("using qId")
          console.log(qId)
            this.questionHelpTextService.getQuestionHelpText2([qId]).subscribe((result: any) => {
                console.log("result from getQuestionHelpText2 is:")
                console.log(result)

                const resultArray = Array.isArray(result?.questionHelpTexts) ? result?.questionHelpTexts : result;

                const selectedHelpText = resultArray.find((item: QuestionHelpText) => item.QUESTIONS_ID === Number(qId));
                if (selectedHelpText)
                {
                  console.log("returned text was: ");
                  console.log(selectedHelpText?.HELP_TEXT?.trim());
                  const dialogConfig = new MatDialogConfig();
                  dialogConfig.autoFocus = true;
                  dialogConfig.maxHeight = '80vh';
          
                  dialogConfig.data = { HELP_TEXT: selectedHelpText?.HELP_TEXT?.trim() };
                  this.dialog.open(QuestionHelpTextComponent, dialogConfig);
                }
                else
                {
                  console.log("No matching item found with QUESTIONS_ID:", qId);
                }
              });
            };  



  displayHelpTextOld(qId: number) {
    console.log("helpTextDialogService now invoking Help Text API the old way")

    this.questionHelpTextService.getHelpText([qId]).subscribe((lstQuestionHelpText: QuestionHelpText[]) => {
      this.lstQuestionHelpText = lstQuestionHelpText;
      console.log("returned text was: ");
      console.log(this.lstQuestionHelpText[0].HELP_TEXT);
        const dialogConfig = new MatDialogConfig();
        dialogConfig.autoFocus = true;
        dialogConfig.maxHeight = '80vh';
  
        dialogConfig.data = { HELP_TEXT: this.lstQuestionHelpText[0].HELP_TEXT };
        this.dialog.open(QuestionHelpTextComponent, dialogConfig);
      });
          

/* OLD WAY 

    this.questionHelpTextService.getHelpText([qId]).subscribe((lstQuestionHelpText: QuestionHelpText[]) => {
          */

  
  }


}